"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselList = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var carousel_list_module_scss_1 = __importDefault(require("./carousel-list.module.scss"));
var CarouselItem_1 = require("../carousel-item/CarouselItem");
var CarouselList = function (_a) {
    var _b;
    var id = _a.id, _c = _a.showVisibleScrollbar, showVisibleScrollbar = _c === void 0 ? false : _c, ulContainerElementRef = _a.ulContainerElementRef, 
    //handleKeyUp,
    items = _a.items;
    //* Pages logic is only for Product Card Carousel.
    var pages = items.reduce(function (pagesArray, item, index) {
        var itemObject = { item: item, itemNumber: index + 1 };
        var pagesIndex = Math.floor(index / 5);
        if (!pagesArray[pagesIndex]) {
            pagesArray[pagesIndex] = [];
        }
        pagesArray[pagesIndex].push(itemObject);
        return pagesArray;
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(carousel_list_module_scss_1.default['carousel__items-container'], (_b = {},
            _b[carousel_list_module_scss_1.default['visibleScrollbar']] = showVisibleScrollbar,
            _b)), role: "list", "data-testid": "carousel-items-container", ref: ulContainerElementRef, id: id }, pages.map(function (page, index) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(carousel_list_module_scss_1.default['carousel__page'], ["carousel__page--number-".concat(index)], carousel_list_module_scss_1.default["carousel__page--".concat(page.length, "-items")]), "data-testid": "carousel-page-".concat(index), "data-pageid": index, key: index }, page.map(function (itemObject, index) { return (react_1.default.createElement(CarouselItem_1.CarouselItem, { item: itemObject.item, index: index, key: "contentKey-".concat(index), itemsCount: items.length, 
            //handleKeyUp={handleKeyUp}
            itemNumber: itemObject.itemNumber })); })));
    })));
};
exports.CarouselList = CarouselList;
//# sourceMappingURL=CarouselList.js.map